// Interfaces for organisation data models

import { CountryModel } from "./country.model";

export const REFRACTIVE_INSTRUMENTS: string[] = [
  "Standalone Autorefactor",
  "Combined Autorefactor + Keratometer",
  "Aberrometer",
  "None"
];

export const ASTIGMATISM_INSTRUMENTS: string[] = [
  "Combined Autorefactor + Keratometer",
  "Standalone Keratometer",
  "Corneal Topographer",
  "My Axial Length Measuring Device",
  "None"
];

export const CATARACT_INSTRUMENTS: string[] = [
  "AL Scan",
  "IOLMaster 500",
  "IOLMaster 700",
  "Lenstar",
  "Myopia Master",
  "Myah	",
  "Occuity",
  "Revo",
  "None"
];

export interface OrgModel {
  id: string;
  legalName: string;
  displayName: string;
  contactEmail: string;
  contactTelephone?: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  postcode?: string;
  country_id: number;
  timezone_id?: number;
  country: CountryModel;
  /* page 2 stuff */
  instruments: string[]
}

export interface CreateOrgModel extends Omit<OrgModel, "country"> {
  autoAssignClinicAdmin: boolean;
}

export interface UpdateOrgModel extends Omit<Partial<OrgModel>, "country"> { }
